var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", [
        _c("div", { staticClass: "columns is-hidden-print" }, [
          _c("div", { staticClass: "column is-hidden-print flex" }, [
            _c("div", { staticClass: "flex-1" }, [
              _c("h1", {
                staticClass: "title text-md lg:text-2xl",
                domProps: { textContent: _vm._s(_vm.nameWithId) }
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "subtitle text-sm lg:text-base" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("span", { staticClass: "mr-4 mb-4 is-inline-block" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatTime(_vm.meeting.start_date) +
                        " - " +
                        _vm.formatTime(_vm.meeting.end_date)
                    )
                  )
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "is-hidden-print",
                  class: [
                    "tag",
                    "has-text-weight-bold",
                    "is-uppercase",
                    this.currentPhase.style
                  ],
                  domProps: { textContent: _vm._s(_vm.currentPhase.text) }
                }),
                _vm._v(" "),
                _vm.meeting.is_archived
                  ? _c(
                      "span",
                      {
                        staticClass: "is-hidden-print",
                        class: [
                          "tag",
                          "haas-text-weight-bold",
                          "is-uppercase",
                          "is-black"
                        ]
                      },
                      [_vm._v("\n              Archived\n            ")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex justify-end lg:hidden pl-3 is-hidden-print"
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.sideBarOpen = !_vm.sideBarOpen
                      }
                    }
                  },
                  [_vm._m(1), _vm._v(" "), _c("span", [_vm._v("Menu")])]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns mt-4" }, [
        _c(
          "div",
          {
            staticClass: "column is-one-quarter is-hidden-print hidden lg:block"
          },
          [
            _c("MeetingMenu", {
              attrs: {
                pageId: _vm.id,
                meeting: _vm.meeting,
                currentPhase: _vm.currentPhase
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("main", { staticClass: "main mb-8 column" }, [_c("router-view")], 1),
        _vm._v(" "),
        _c("div", [
          _c(
            "form",
            {
              ref: "formExportUsers",
              attrs: { action: _vm.functionUrl, method: "post" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.token,
                    expression: "token"
                  }
                ],
                attrs: { name: "token" },
                domProps: { value: _vm.token },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.token = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.id,
                    expression: "id"
                  }
                ],
                attrs: { name: "meetingId" },
                domProps: { value: _vm.id },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.id = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userInfo,
                    expression: "userInfo"
                  }
                ],
                attrs: { name: "userInfo" },
                domProps: { value: _vm.userInfo },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.userInfo = $event.target.value
                  }
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-sidebar",
        {
          attrs: {
            fullheight: true,
            fullwidth: false,
            overlay: true,
            right: true
          },
          model: {
            value: _vm.sideBarOpen,
            callback: function($$v) {
              _vm.sideBarOpen = $$v
            },
            expression: "sideBarOpen"
          }
        },
        [
          _c("MeetingMenu", {
            staticClass: "p-4",
            attrs: {
              pageId: _vm.id,
              meeting: _vm.meeting,
              currentPhase: _vm.currentPhase
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fas fa-calendar-alt" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "icon", attrs: { "aria-hidden": "true" } },
      [_c("i", { staticClass: "fas fa-ellipsis-v" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb1b36e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb1b36e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MeetingDashboard.vue
// module id = null
// module chunks = 